import { cx } from "class-variance-authority";
import WarningIcon from "./warning-icon.svg";

type ValidationMessageProps = {
  shouldShowValidation?: boolean;
  validationMessage?: string;
};

export const ValidationMessage = (props: ValidationMessageProps) => {
  if (!props.shouldShowValidation || !props.validationMessage) return null;
  return (
    <div className="flex items-center gap-2 font-medium">
      <WarningIcon />
      <p className={cx("text-sm text-ui-red")}>{props.validationMessage}</p>
    </div>
  );
};
